import React from 'react';

const SortDirectionControl = ({ order }) => (
  <span
    aria-hidden='true'
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 28,
      height: 28,
      border: '1px solid #d9d9d9',
      borderRadius: 4,
      color: order ? '#1890ff' : '#8c8c8c',
      fontSize: 16,
      lineHeight: 1,
      verticalAlign: 'middle',
      cursor: 'default',
      userSelect: 'none'
    }}
  >
    {order === 'asc' ? '↑' : order === 'desc' ? '↓' : '↕'}
  </span>
);

export default SortDirectionControl;
